// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
// GSAP page fade in animations

document.addEventListener('DOMContentLoaded', function() {
  // Force white background on widget section
  const widgetSections = document.querySelectorAll('.shopify-section:has(.section-bxyz-widget)');
  widgetSections.forEach(section => {
    section.style.setProperty('background-color', '#FFFFFF', 'important');
    const sectionBg = section.querySelector('.section-background');
    if (sectionBg) {
      sectionBg.style.setProperty('background-color', '#FFFFFF', 'important');
      sectionBg.style.setProperty('display', 'none', 'important');
    }
  });
  
  // Register GSAP ScrollTrigger
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }
  
  // Fade in page on load
  gsap.from('body', {
    opacity: 0,
    duration: 0.8,
    ease: 'power2.out'
  });
  
  // Fade in header
  gsap.from('.bxyzens-header', {
    opacity: 0,
    y: -20,
    duration: 0.6,
    delay: 0.2,
    ease: 'power2.out'
  });
  
  // Fade in footer
  gsap.from('.bxyzens-footer', {
    opacity: 0,
    y: 20,
    duration: 0.6,
    delay: 0.2,
    ease: 'power2.out'
  });
  
  // Fade in fullscreen slides
  gsap.utils.toArray('.bxyzens-fullscreen__slide').forEach((slide, index) => {
    gsap.from(slide, {
      opacity: 0,
      scale: 0.95,
      duration: 0.8,
      delay: 0.3 + (index * 0.1),
      ease: 'power2.out',
      scrollTrigger: {
        trigger: slide,
        start: 'top 80%',
        toggleActions: 'play none none none'
      }
    });
  });
  
  // Fade in form
  gsap.from('.bxyzens-form', {
    opacity: 0,
    y: 30,
    duration: 0.8,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: '.bxyzens-form',
      start: 'top 80%',
      toggleActions: 'play none none none'
    }
  });
  
  // Fade in form fields one by one
  gsap.utils.toArray('.bxyzens-form__field').forEach((field, index) => {
    gsap.from(field, {
      opacity: 0,
      x: -20,
      duration: 0.5,
      delay: 0.5 + (index * 0.1),
      ease: 'power2.out',
      scrollTrigger: {
        trigger: '.bxyzens-form',
        start: 'top 70%',
        toggleActions: 'play none none none'
      }
    });
  });
  
  // Animate widget blobs on scroll
  gsap.utils.toArray('.bxyz-widget__item').forEach((widget, index) => {
    gsap.from(widget, {
      opacity: 0,
      y: 60,
      scale: 0.9,
      duration: 0.8,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: widget,
        start: 'top 85%',
        toggleActions: 'play none none none'
      }
    });
  });
});
